export default __webpack_public_path__ + "static/analytics-56d52ccf68017425a45cc34ff683bd8f.mp4";